(() => {
  if (window.vaseniaBuilderCartReady) return;
  window.vaseniaBuilderCartReady = true;
  let running = false;
  document.addEventListener('vasenia:builder:submit', async (event) => {
    event.preventDefault();
    const host = event.target;
    const detail = event.detail;
    if (running || !detail || !Array.isArray(detail.items)) return;
    const text = (key, fallback) => host.dataset[key] || fallback;
    const status = (message, error = true) => host.setStatus(message, error);
    const root = window.Shopify?.routes?.root || '/';
    const request = async (path, body) => {
      const response = await fetch(`${root}${path}`, {
        method: body ? 'POST' : 'GET',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
        ...(body ? { body: JSON.stringify(body) } : {})
      });
      const data = await response.json();
      if (!response.ok || data.status >= 400) throw new Error('cart_request_failed');
      return data;
    };
    const items = detail.items;
    const ids = items.map(item => String(item.id));
    if (items.length < 2 || items.length > 4 || new Set(ids).size !== items.length || !detail.discountCode || detail.currency !== 'USD') return;
    running = true;
    host.setBusy(true);
    status('', false);
    try {
      const before = await request('cart.js');
      if (before.currency !== 'USD') {
        status(text('cartCurrency', 'This bundle is available in USD. Please review your currency before continuing.'));
        return;
      }
      if (before.items.some(item => ids.includes(String(item.variant_id)))) {
        status(text('cartDuplicate', 'One of these patterns is already in your cart. Choose a different pattern or review your cart below.'));
        return;
      }
      const builderCodes = new Set(Object.values(host.config?.discountCodes || {}).map(code => String(code).toUpperCase()));
      const hasDiscount = Number(before.total_discount) > 0 ||
        (before.cart_level_discount_applications || []).length > 0 ||
        (before.discount_codes || []).some(code => {
          const name = String(code.code || '').trim().toUpperCase();
          const staleBuilderCode = before.items.length === 0 && code.applicable === false && builderCodes.has(name);
          return name && !staleBuilderCode;
        }) ||
        before.items.some(item => (item.line_level_discount_allocations || []).length > 0 ||
          (item.discounts || []).length > 0 || item.selling_plan_allocation ||
          Object.keys(item.properties || {}).some(key => /kaching|bundle/i.test(key)));
      if (hasDiscount) {
        status(text('cartExistingDiscount', 'Your cart already has a discounted offer. Please review it before adding another bundle; your current offer has been kept.'));
        return;
      }
      const bundleKey = `vpb-${Date.now().toString(36)}`;
      await request('cart/add.js', { items: items.map(item => ({
        id: item.id,
        quantity: 1,
        properties: { _vasenia_builder: bundleKey }
      })) });
      const after = await request('cart/update.js', { discount: detail.discountCode });
      const added = after.items.filter(item => item.properties?._vasenia_builder === bundleKey);
      const expectedTotal = Number(before.total_price) + Number(detail.subtotal) - Number(detail.savings);
      const addedIds = added.map(item => String(item.variant_id));
      const complete = added.length === items.length && new Set(addedIds).size === ids.length && added.every(item => item.quantity === 1 && ids.includes(String(item.variant_id)));
      const lineIdentity = item => JSON.stringify({
        id: String(item.variant_id), quantity: item.quantity,
        properties: Object.entries(item.properties || {}).sort(([a], [b]) => a.localeCompare(b)),
        sellingPlan: item.selling_plan_allocation?.selling_plan?.id || null
      });
      const beforeLines = before.items.map(lineIdentity).sort();
      const preservedLines = after.items.filter(item => item.properties?._vasenia_builder !== bundleKey).map(lineIdentity).sort();
      const preserved = JSON.stringify(beforeLines) === JSON.stringify(preservedLines);
      const expectedCode = String(detail.discountCode).toUpperCase();
      const allocations = [
        ...(after.cart_level_discount_applications || []),
        ...after.items.flatMap(item => (item.line_level_discount_allocations || []).map(allocation => allocation.discount_application))
      ].filter(Boolean);
      const correctCode = (after.discount_codes || []).some(code => code.applicable === true && String(code.code).toUpperCase() === expectedCode) ||
        allocations.some(discount => discount.type === 'discount_code' && String(discount.title).toUpperCase() === expectedCode);
      if (!complete || !preserved || !correctCode || Number(after.total_discount) !== Number(detail.savings) || Number(after.total_price) !== expectedTotal) {
        status(text('cartPriceChanged', 'Your patterns are in the cart, but the total needs a review. Please check your cart below before continuing.'));
        return;
      }
      window.location.assign(`${root}cart`);
    } catch (error) {
      status(text('cartError', 'We could not finish updating your bundle. Please check your cart below before trying again.'));
    } finally {
      running = false;
      host.setBusy(false);
    }
  });
})();
